import React, { useEffect } from "react";
import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import GalleryTeaser from "@/components/site/GalleryTeaser";
import Lunch from "@/components/site/Lunch";
import OpeningHours from "@/components/site/OpeningHours";
import Events from "@/components/site/Events";
import About from "@/components/site/About";
import DailySpecial from "@/components/site/DailySpecial";
import MenuSection from "@/components/site/MenuSection";
import Reviews from "@/components/site/Reviews";
import OrderSection from "@/components/site/OrderSection";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import StickyMobileCTA from "@/components/site/StickyMobileCTA";
import api from "@/lib/api";
import { useSection } from "@/context/SiteContext";

export default function Landing() {
  const features = useSection("features");
  const on = (key) => features[key] !== false; // default ON if not explicitly false

  useEffect(() => {
    // Anonymous page-view tracking. Only landing page; one ping per session.
    try {
      const KEY = "monami_visit_tracked";
      if (!sessionStorage.getItem(KEY)) {
        api.post("/analytics/track", {
          path: window.location.pathname,
          referrer: document.referrer || "",
        }).catch((err) => console.error("Analytics track failed:", err));
        sessionStorage.setItem(KEY, "1");
      }
    } catch (err) {
      console.error("Analytics setup failed:", err);
    }
  }, []);

  return (
    <div className="min-h-screen bg-[var(--bg)]">
      <Header />
      <main>
        <Hero />
        {on("gallery_teaser") && <GalleryTeaser />}
        {on("lunch") && <Lunch />}
        {on("hours_section") && <OpeningHours />}
        {on("events") && <Events />}
        <MenuSection />
        <About />
        {on("daily_special") && <DailySpecial />}
        {on("reviews") && <Reviews />}
        {on("order_section") && <OrderSection />}
        <Contact />
      </main>
      <Footer />
      <StickyMobileCTA />
    </div>
  );
}
